import { SearchField, Box, InputProps, BoxProps, XStack, SizableText } from '@my/ui'
import { FilterOption, GroupFilter, SortOption } from '../group-filter'

interface GroupSearchProps {
  query: string
  totalResults?: number
  onSearchChange: (value: string) => void
  onFilterChange: (filter: FilterOption) => void
  onSortChange: (sortOption: SortOption) => void
  sortOptions: SortOption[]
  activeSortOption: SortOption | null
  activeFilters: FilterOption[]
  filters?: FilterOption[]
  inputProps?: InputProps
}

export const GroupSearch = ({
  filters,
  query,
  totalResults,
  onSearchChange,
  onFilterChange,
  activeFilters,
  onSortChange,
  activeSortOption,
  sortOptions,
  inputProps,
  ...props
}: GroupSearchProps & BoxProps) => {
  return (
    <Box flex={1} fd="column" jc="flex-start" ai="flex-start" gap="$3.5" {...props}>
      <SearchField
        value={query}
        onSearchChange={onSearchChange}
        w="100%"
        inputProps={{
          h: '$4',
          py: '$2',
          pr: '$11',
          boc: '$overlay4',
          placeholder: 'Search groups',
          ...inputProps,
        }}
      />
      {query?.length > 2 && (
        <XStack w="100%" flex={1} ai="flex-start" jc="space-between" gap="$3.5">
          <XStack flex={1} gap="$2" flexWrap="wrap">
            <SizableText size="$5" color="$overlay10" fow="600" $gtSm={{ size: '$6', fow: '600' }}>
              Results for
            </SizableText>
            <SizableText
              numberOfLines={1}
              size="$5"
              color="$overlay12"
              fow="600"
              $gtSm={{ size: '$6', fow: '600' }}
            >
              {query}
            </SizableText>
          </XStack>
          <SizableText
            br="$2"
            size="$5"
            py="$1"
            px="$2"
            bg="$overlay3"
            color="$overlay10"
            fow="600"
            $gtSm={{ size: '$6', fow: '600' }}
          >
            {totalResults || 0}
          </SizableText>
        </XStack>
      )}
      <GroupFilter
        sortOptions={sortOptions}
        onSortChange={onSortChange}
        activeSortOption={activeSortOption}
        filters={filters}
        onFilterChange={onFilterChange}
        activeFilters={activeFilters}
      />
    </Box>
  )
}
